module.exports = __webpack_public_path__ + "static/img/ncp.baf4727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ncp.png
// module id = RRCM
// module chunks = 1